<template>
  <div>
    <div v-for="(section, index) in sections" :key="index" class="section-container">
      <h1 class="section-title">{{section.name}}</h1>
      <div>
        <span
          class="sort-btn"
          v-if="section.sort && !section.reordered"
          @click="section.sort = false"
        >Cancelar</span>
        <span
          class="sort-btn"
          v-else-if="section.sort && section.reordered"
          @click="saveOrder(index)"
        >Guardar</span>
        <span class="sort-btn" v-else @click="startSort(index)">{{$t('info.reorder')}}</span>
      </div>
      <div class="cards-container">
        <!-- New Post -->
        <div class="btn-container" @click="newArticle(section)">
          <InfoCard :addBtn="true">+</InfoCard>
        </div>
        <!-- Drag & Drop -->
        <draggable
          :disabled="!section.sort"
          :list="section.articles"
          @change="section.reordered = true"
          class="droppable"
        >
          <InfoCard
            v-for="(article, i) in section.articles"
            :key="i"
            :class="{'draggable': section.sort}"
          >
            <template #header>{{article.title}}</template>
            <!-- <template #sub>Alerta - Actualizado<br>06/Ago/2019</template> -->
            <template>{{article.subtitle}}</template>
            <template #right-control>
              <router-link
                class="icons-black"
                :to="{
                name: 'Info Edit',
                params: {
                  articleId: article.postId
                }
              }"
              >
                <i class="far fa-edit icons-black"></i>
              </router-link>
              <span @click="openModal(article.postId)">
                <i class="far fa-trash-alt icons-black"></i>
              </span>
            </template>
          </InfoCard>
        </draggable>
      </div>
    </div>
    <!-- Modal -->
    <Modal v-if="modalActive" v-on:closeModal="closeModal">
      <template #header>
        <h6 class="modal-title">{{$t('deleteInfo.title')}}</h6>
      </template>
      <template>
        <p>{{$t('deleteInfo.body')}}</p>
      </template>
      <template #footer>
        <div class="controls">
          <span class="control cancel-btn" @click="closeModal">{{$t('deleteInfo.cancel')}}</span>
          <button
            type="control button"
            class="btn btn-dark control delete-btn"
            :disabled="isLoading"
            @click="deleteArticle"
          >{{$t('deleteInfo.delete')}}</button>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import GenInfo from "@/lib/api/GeneralInfo";
import draggable from "vuedraggable";
const InfoCard = () => import("@/components/InfoCard");
const Modal = () => import("@/components/Modal");

export default {
  components: {
    draggable,
    InfoCard,
    Modal
  },
  data: function() {
    return {
      isLoading: false,
      sections: null,
      modalActive: false,
      articleId: null
    };
  },
  beforeMount: function() {
    this.getArticles();
  },
  destroyed: function() {
    this.sections.forEach(section => {
      section.sort = false;
      section.reordered = false;
    });
  },
  methods: {
    getArticles: async function() {
      this.$store.commit("global/SET_LOADING", true);
      const service = new GenInfo();
      try {
        const response = await service.getArticles();
        for (let index = 0; index < response.length; index++) {
          switch (response[index].name) {
            case "Compañía":
              response[index].name = this.$t("info.titles.company");
              break;
            case "Naves de Producción":
              response[index].name = this.$t("info.titles.production");
              break;
            case "Comité Ejecutivo":
              response[index].name = this.$t("info.titles.committee");
              break;
            case "Publicación Comité":
              response[index].name = this.$t("info.titles.committeePublish");
              break;
            case "Sustentabilidad":
              response[index].name = this.$t("info.titles.sustainability");
              break;
            case "Publicación Sustentabilidad":
              response[index].name = this.$t(
                "info.titles.sustainabilityPublish"
              );
              break;
            case "Videos":
              response[index].name = this.$t("info.titles.videos");
              break;
            case "Ubicación":
              response[index].name = this.$t("info.titles.location");
              break;
          }
        }
        this.sections = response;
        this.$store.commit("global/SET_LOADING", false);
      } catch (error) {
        this.$store.commit("global/SET_LOADING", false);
        throw error;
      }
    },
    newArticle: function(section) {
      let orders;
      if (section.articles) {
        orders = section.articles.map(article => article.extra.order);
      } else {
        orders = [0];
      }
      const maxOrder = Math.max(...orders);
      let lastArticle = null;
      if (section.articles) {
        lastArticle = section.articles.filter(
          article => article.extra.order == maxOrder
        );
      }
      this.$router.push({
        name: "Info New",
        params: {
          section: section.id,
          order: lastArticle ? lastArticle[0].extra.order + 1 : 0
        }
      });
    },
    openModal: function(id) {
      this.articleId = id;
      this.modalActive = true;
    },
    closeModal: function(id) {
      this.articleId = null;
      this.modalActive = false;
    },
    deleteArticle: async function() {
      this.$store.commit("global/SET_LOADING", true);
      this.isLoading = true;
      const service = new GenInfo();
      try {
        await service.deleteArticle(this.articleId);
        this.isLoading = false;
        this.$store.commit("global/SET_LOADING", false);
        this.closeModal();
        this.getArticles();
      } catch (error) {
        this.isLoading = false;
        this.$store.commit("global/SET_LOADING", false);
        throw error;
      }
    },
    startSort: function(index) {
      this.sections[index].sort = true;
    },
    saveOrder: async function(index) {
      this.$store.commit("global/SET_LOADING", true);
      this.isLoading = true;
      const service = new GenInfo();
      try {
        const newOrder = this.changeOrder(this.sections[index]);
        this.sections[index].articles = newOrder;
        // Update Articles
        const requests = this.sections[index].articles.map(async article => {
          return await service.updateArticle(article, article.postId);
        });
        Promise.all(requests);
        this.sections[index].sort = false;
        this.sections[index].reordered = false;
        this.isLoading = false;
        this.$store.commit("global/SET_LOADING", false);
        // this.getArticles();
      } catch (error) {
        this.isLoading = false;
        this.$store.commit("global/SET_LOADING", false);
        throw error;
      }
    },
    changeOrder: function(section) {
      return section.articles.map((article, index) => {
        article.extra.order = section.articles.length - 1 - index;
        return article;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.section-container {
  margin: 40px 0px;

  .section-title {
    margin-bottom: 10px;
  }
  .sort-btn {
    cursor: pointer;
  }
  .cards-container {
    display: flex;
    flex-wrap: no-wrap;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
  }
  .btn-container {
    display: contents;
  }
  .droppable {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
  }
  .draggable {
    cursor: move;
  }
}

.edit-btn {
  color: $black;
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);

  &:hover {
    color: $black;
  }
}

.delete-btn {
  @extend %audi;
  color: $black;
  cursor: pointer;
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);

  &:hover {
    color: $warn_red;
    text-decoration: underline;
  }
}

.modal-title {
  margin: 0;
}
.controls {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
.controls .control {
  margin-left: 15px;
  font-size: 16px;
  cursor: pointer;
}
.control.cancel-btn {
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);

  &:hover {
    text-decoration: underline;
  }
}
.control.delete-btn {
  @extend %audi-b;
  color: $white;
  background-color: $black;
  border-color: $black;
  padding: 10px 20px;
  border-radius: 0px;
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);

  &:hover {
    background-color: $warn_red;
    border-color: $warn_red;
  }
}
.icons-black {
  color: #000;
  font-size: 16px;
  cursor: pointer;
}
</style>
